var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"flex justify-center shadow-md transform hover:-translate-y-1 duration-200 hover:bg-gray-100 rounded",on:{"click":_vm.addToCart}},[_c('shopping-bag-logo-white',{staticClass:"p-0"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }